export default [
  { id: 'desktop', name: 'Desktop', width: '' },
  { id: 'tablet', name: 'Tablet', width: '1024px', widthMedia: '1024px' },
  { id: 'mobile', name: 'Mobile', width: '767px', widthMedia: '767px' },
]

export const DEVICE_ICONS = {
  desktop: 'fa-desktop',
  tablet: 'fa-tablet',
  mobile: 'fa-mobile',
}

export const VISIBILITY_STYLES = `
.eb-hide-desktop { }
.eb-hide-tablet { }
.eb-hide-mobile { }
@media (min-width: 1025px) {
  .eb-hide-desktop { display: none !important; }
}
@media (max-width: 1024px) and (min-width: 768px) {
  .eb-hide-tablet { display: none !important; }
}
@media (max-width: 767px) {
  .eb-hide-mobile { display: none !important; }
}
`
